module.exports = __webpack_public_path__ + "img/small.f32853f0.jpg";